// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Device Selector Component */
.device-selector {
  background: #000000;
  border: 1px solid #1f2937;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

.device-selector-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.device-selector-title {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #f3f4f6;
  flex: 1 1;
}

.device-selector-title h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.device-selector-count {
  font-size: 14px;
  color: #9ca3af;
  font-weight: 400;
}

.device-selector-actions {
  display: flex;
  gap: 8px;
}

.device-selector-btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  border: 1px solid #22c55e;
  border-radius: 6px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
  width: 32px;
  height: 32px;
}

.device-selector-btn-icon:hover {
  background: linear-gradient(135deg, #16a34a, #15803d);
  border-color: #16a34a;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(34, 197, 94, 0.3);
}

.device-selector-btn-icon:active {
  transform: translateY(0);
}

.device-selector-btn-action-add {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: linear-gradient(135deg, #60a5fa, #3b82f6);
  border: 1px solid #60a5fa;
  border-radius: 6px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.device-selector-btn-action-add:hover {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  border-color: #3b82f6;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

.device-selector-btn-action-add:active {
  transform: translateY(0);
}

.device-selector-btn-action-remove {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 6px;
  color: #f87171;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.device-selector-btn-action-remove:hover {
  background: rgba(239, 68, 68, 0.2);
  border-color: rgba(239, 68, 68, 0.5);
  color: #fca5a5;
  transform: translateY(-1px);
}

.device-selector-btn-action-remove:active {
  transform: translateY(0);
}

.device-selector-btn-create {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: transparent;
  border: 1.5px solid #da3633;
  border-radius: 6px;
  color: #da3633;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.device-selector-btn-create:hover {
  background: rgba(218, 54, 51, 0.1);
  border-color: #A61B34;
  color: #A61B34;
  transform: translateY(-1px);
}

.device-selector-btn-create:active {
  transform: translateY(0);
  background: rgba(218, 54, 51, 0.2);
}

.device-selector-btn-finish {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: transparent;
  border: 1.5px solid #22c55e;
  border-radius: 6px;
  color: #22c55e;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.device-selector-btn-finish:hover {
  background: rgba(34, 197, 94, 0.1);
  border-color: #16a34a;
  color: #16a34a;
  transform: translateY(-1px);
}

.device-selector-btn-finish:active {
  transform: translateY(0);
  background: rgba(34, 197, 94, 0.2);
}

.device-selector-btn-secondary {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 6px;
  color: #e5e7eb;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.device-selector-btn-secondary:hover {
  background: #1a1a1a;
  border-color: #4b5563;
  color: #ffffff;
}

.filter-indicator {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 6px;
  height: 6px;
  background: #3b82f6;
  border-radius: 50%;
}

/* Max Selection Warning Banner */
.device-selector-max-warning {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  margin-bottom: 12px;
  background: rgba(251, 146, 60, 0.1);
  border: 1px solid rgba(251, 146, 60, 0.35);
  border-radius: 8px;
  animation: warningSlideIn 0.3s ease-out;
}

.device-selector-max-warning-content {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fb923c;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
}

.device-selector-max-warning-content svg {
  flex-shrink: 0;
}

.device-selector-max-warning-close {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: none;
  border: none;
  color: #fb923c;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  flex-shrink: 0;
  opacity: 0.7;
}

.device-selector-max-warning-close:hover {
  opacity: 1;
  background: rgba(251, 146, 60, 0.15);
}

@keyframes warningSlideIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Search Bar */
.device-selector-search {
  position: relative;
  margin-bottom: 12px;
}

.device-selector-search .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
}

.device-selector-search-input {
  width: 100%;
  padding: 10px 40px 10px 40px;
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 6px;
  color: #f3f4f6;
  font-size: 14px;
  transition: all 0.2s;
}

.device-selector-search-input:focus {
  outline: none;
  border-color: #60a5fa;
  background: #000000;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);
}

.device-selector-search-input::placeholder {
  color: #6b7280;
}

.search-clear {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}

.search-clear:hover {
  color: #d1d5db;
}

/* Filters Panel */
.device-selector-filters {
  background: #0a0a0a;
  border: 1px solid #1f2937;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 12px;
}

.filter-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  align-items: end;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.filter-group label {
  font-size: 13px;
  color: #9ca3af;
  font-weight: 500;
}

.filter-select {
  padding: 8px 12px;
  background: #000000;
  border: 1px solid #374151;
  border-radius: 6px;
  color: #f3f4f6;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.filter-select:focus {
  outline: none;
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);
}

.filter-clear-btn {
  padding: 8px 16px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 6px;
  color: #f87171;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.filter-clear-btn:hover {
  background: rgba(239, 68, 68, 0.2);
  border-color: rgba(239, 68, 68, 0.5);
}

/* Info Bar */
.device-selector-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 0;
}

.results-count {
  font-size: 13px;
  color: #9ca3af;
}

.select-all-btn {
  padding: 6px 12px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 6px;
  color: #93c5fd;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.select-all-btn:hover {
  background: rgba(59, 130, 246, 0.2);
  border-color: rgba(59, 130, 246, 0.5);
}

/* Device List */
.device-selector-list {
  max-height: 400px;
  overflow-y: auto;
}

.device-selector-empty {
  text-align: center;
  padding: 40px 20px;
  color: #9ca3af;
}

.device-selector-empty p {
  margin: 0 0 16px 0;
}

.clear-filters-btn {
  padding: 8px 16px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 6px;
  color: #93c5fd;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.clear-filters-btn:hover {
  background: rgba(59, 130, 246, 0.2);
  border-color: rgba(59, 130, 246, 0.5);
}

/* Device Table */
.device-table-wrapper {
  overflow-x: auto;
  background: #000000;
  border-radius: 6px;
}

.device-table {
  width: 100%;
  border-collapse: collapse;
}

.device-table thead {
  background: #0a0a0a;
  position: sticky;
  top: 0;
  z-index: 1;
}

.device-table th {
  padding: 10px 12px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #1f2937;
}

.device-table tbody tr {
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid #1f2937;
}

.device-table tbody tr:hover {
  background: #0a0a0a;
}

.device-table tbody tr.selected {
  background: rgba(96, 165, 250, 0.15);
}

.device-table tbody tr.selected:hover {
  background: rgba(96, 165, 250, 0.25);
}

.device-table td {
  padding: 12px;
  font-size: 14px;
  color: #e5e7eb;
}

.device-checkbox {
  width: 20px;
  height: 20px;
  border: 2px solid #4b5563;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  background: #000000;
}

.device-row.selected .device-checkbox {
  background: #60a5fa;
  border-color: #60a5fa;
  color: white;
}

.device-serial {
  font-family: 'Courier New', monospace;
  font-weight: 500;
  color: #f3f4f6;
}

.device-mac {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: #9ca3af;
}

.device-status {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.device-status.active {
  background: rgba(34, 197, 94, 0.15);
  color: #86efac;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.device-status.inactive {
  background: rgba(107, 114, 128, 0.15);
  color: #9ca3af;
  border: 1px solid rgba(107, 114, 128, 0.3);
}

.device-table tbody tr.assigned {
  background: rgba(107, 114, 128, 0.15);
  opacity: 1;
}

.device-table tbody tr.assigned:hover {
  background: rgba(107, 114, 128, 0.2);
}

.device-table tbody tr.assigned-to-other {
  background: rgba(239, 68, 68, 0.08);
  opacity: 1;
}

.device-table tbody tr.assigned-to-other:hover {
  background: rgba(239, 68, 68, 0.12);
}

.device-table tbody tr.assigned-to-other td {
  color: #d1d5db;
}

.device-table tbody tr.assigned-to-other .device-serial {
  color: #e5e7eb;
  opacity: 0.9;
}

.device-table tbody tr.assigned-to-other .device-mac {
  color: #9ca3af;
  opacity: 0.9;
}

.device-table tbody tr.assigned-to-current {
  background: rgba(34, 197, 94, 0.05);
  opacity: 1;
}

.device-table tbody tr.assigned-to-current:hover {
  background: rgba(34, 197, 94, 0.08);
}

.device-checkbox.disabled {
  background: rgba(75, 85, 99, 0.4);
  border-color: rgba(75, 85, 99, 0.6);
  cursor: not-allowed;
}

.disabled-text {
  color: #9ca3af !important;
}

.dimmed-text {
  color: #9ca3af !important;
}

.device-status.disabled,
.device-status.dimmed {
  opacity: 0.8;
}

.device-site-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background: rgba(239, 68, 68, 0.15);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.device-site-badge-assigned {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background: rgba(251, 146, 60, 0.15);
  color: #fb923c;
  border: 1px solid rgba(251, 146, 60, 0.3);
}

.device-available-badge {
  display: inline-flex;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background: rgba(34, 197, 94, 0.15);
  color: #86efac;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.device-available-badge.current-site {
  background: rgba(156, 163, 175, 0.15);
  color: #9ca3af;
  border: 1px solid rgba(156, 163, 175, 0.3);
  gap: 4px;
  display: inline-flex;
  align-items: center;
}

.device-site-badge-current {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
  border: 1px solid rgba(59, 130, 246, 0.3);
}

.device-assigned-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.device-actions-cell {
  text-align: center;
  vertical-align: middle;
}

.device-edit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: #374151;
  border: none;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 4px;
}

.device-edit-btn:hover {
  background: #4B5563;
  color: #fbbf24;
  transform: scale(1.05);
}

.device-edit-btn:active {
  transform: scale(0.95);
}

.device-reassign-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 4px;
  color: #60a5fa;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.device-reassign-btn:hover {
  background: rgba(59, 130, 246, 0.2);
  border-color: rgba(59, 130, 246, 0.5);
  color: #93c5fd;
  transform: translateY(-1px);
}

.device-reassign-btn:active {
  transform: translateY(0);
}

/* Scrollbar personalizado */
.device-selector-list::-webkit-scrollbar {
  width: 8px;
}

.device-selector-list::-webkit-scrollbar-track {
  background: #000000;
  border-radius: 4px;
}

.device-selector-list::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}

.device-selector-list::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

/* Responsive */
@media (max-width: 768px) {
  .filter-row {
    grid-template-columns: 1fr;
  }

  .device-selector-header {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .device-selector-actions {
    width: 100%;
  }

  .device-selector-btn-secondary {
    flex: 1 1;
  }

  .device-table {
    font-size: 12px;
  }

  .device-table th,
  .device-table td {
    padding: 8px;
  }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.spin-animation {
  animation: spin 1s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./src/components/DeviceSelector.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,SAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qDAAqD;EACrD,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qDAAqD;EACrD,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;EAC1C,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;EAC1C,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["/* Device Selector Component */\n.device-selector {\n  background: #000000;\n  border: 1px solid #1f2937;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n}\n\n.device-selector-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.device-selector-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #f3f4f6;\n  flex: 1;\n}\n\n.device-selector-title h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.device-selector-count {\n  font-size: 14px;\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.device-selector-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.device-selector-btn-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n  background: linear-gradient(135deg, #22c55e, #16a34a);\n  border: 1px solid #22c55e;\n  border-radius: 6px;\n  color: #ffffff;\n  cursor: pointer;\n  transition: all 0.2s;\n  width: 32px;\n  height: 32px;\n}\n\n.device-selector-btn-icon:hover {\n  background: linear-gradient(135deg, #16a34a, #15803d);\n  border-color: #16a34a;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(34, 197, 94, 0.3);\n}\n\n.device-selector-btn-icon:active {\n  transform: translateY(0);\n}\n\n.device-selector-btn-action-add {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: linear-gradient(135deg, #60a5fa, #3b82f6);\n  border: 1px solid #60a5fa;\n  border-radius: 6px;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.device-selector-btn-action-add:hover {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  border-color: #3b82f6;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);\n}\n\n.device-selector-btn-action-add:active {\n  transform: translateY(0);\n}\n\n.device-selector-btn-action-remove {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 6px;\n  color: #f87171;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.device-selector-btn-action-remove:hover {\n  background: rgba(239, 68, 68, 0.2);\n  border-color: rgba(239, 68, 68, 0.5);\n  color: #fca5a5;\n  transform: translateY(-1px);\n}\n\n.device-selector-btn-action-remove:active {\n  transform: translateY(0);\n}\n\n.device-selector-btn-create {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  background: transparent;\n  border: 1.5px solid #da3633;\n  border-radius: 6px;\n  color: #da3633;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.device-selector-btn-create:hover {\n  background: rgba(218, 54, 51, 0.1);\n  border-color: #A61B34;\n  color: #A61B34;\n  transform: translateY(-1px);\n}\n\n.device-selector-btn-create:active {\n  transform: translateY(0);\n  background: rgba(218, 54, 51, 0.2);\n}\n\n.device-selector-btn-finish {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  background: transparent;\n  border: 1.5px solid #22c55e;\n  border-radius: 6px;\n  color: #22c55e;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.device-selector-btn-finish:hover {\n  background: rgba(34, 197, 94, 0.1);\n  border-color: #16a34a;\n  color: #16a34a;\n  transform: translateY(-1px);\n}\n\n.device-selector-btn-finish:active {\n  transform: translateY(0);\n  background: rgba(34, 197, 94, 0.2);\n}\n\n.device-selector-btn-secondary {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 6px;\n  color: #e5e7eb;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n}\n\n.device-selector-btn-secondary:hover {\n  background: #1a1a1a;\n  border-color: #4b5563;\n  color: #ffffff;\n}\n\n.filter-indicator {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 6px;\n  height: 6px;\n  background: #3b82f6;\n  border-radius: 50%;\n}\n\n/* Max Selection Warning Banner */\n.device-selector-max-warning {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 14px;\n  margin-bottom: 12px;\n  background: rgba(251, 146, 60, 0.1);\n  border: 1px solid rgba(251, 146, 60, 0.35);\n  border-radius: 8px;\n  animation: warningSlideIn 0.3s ease-out;\n}\n\n.device-selector-max-warning-content {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fb923c;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.device-selector-max-warning-content svg {\n  flex-shrink: 0;\n}\n\n.device-selector-max-warning-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  background: none;\n  border: none;\n  color: #fb923c;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s;\n  flex-shrink: 0;\n  opacity: 0.7;\n}\n\n.device-selector-max-warning-close:hover {\n  opacity: 1;\n  background: rgba(251, 146, 60, 0.15);\n}\n\n@keyframes warningSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Search Bar */\n.device-selector-search {\n  position: relative;\n  margin-bottom: 12px;\n}\n\n.device-selector-search .search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  pointer-events: none;\n}\n\n.device-selector-search-input {\n  width: 100%;\n  padding: 10px 40px 10px 40px;\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 6px;\n  color: #f3f4f6;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.device-selector-search-input:focus {\n  outline: none;\n  border-color: #60a5fa;\n  background: #000000;\n  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);\n}\n\n.device-selector-search-input::placeholder {\n  color: #6b7280;\n}\n\n.search-clear {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  transition: color 0.2s;\n}\n\n.search-clear:hover {\n  color: #d1d5db;\n}\n\n/* Filters Panel */\n.device-selector-filters {\n  background: #0a0a0a;\n  border: 1px solid #1f2937;\n  border-radius: 6px;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.filter-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 12px;\n  align-items: end;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.filter-group label {\n  font-size: 13px;\n  color: #9ca3af;\n  font-weight: 500;\n}\n\n.filter-select {\n  padding: 8px 12px;\n  background: #000000;\n  border: 1px solid #374151;\n  border-radius: 6px;\n  color: #f3f4f6;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #60a5fa;\n  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);\n}\n\n.filter-clear-btn {\n  padding: 8px 16px;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 6px;\n  color: #f87171;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.filter-clear-btn:hover {\n  background: rgba(239, 68, 68, 0.2);\n  border-color: rgba(239, 68, 68, 0.5);\n}\n\n/* Info Bar */\n.device-selector-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding: 8px 0;\n}\n\n.results-count {\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.select-all-btn {\n  padding: 6px 12px;\n  background: rgba(59, 130, 246, 0.1);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  border-radius: 6px;\n  color: #93c5fd;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.select-all-btn:hover {\n  background: rgba(59, 130, 246, 0.2);\n  border-color: rgba(59, 130, 246, 0.5);\n}\n\n/* Device List */\n.device-selector-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.device-selector-empty {\n  text-align: center;\n  padding: 40px 20px;\n  color: #9ca3af;\n}\n\n.device-selector-empty p {\n  margin: 0 0 16px 0;\n}\n\n.clear-filters-btn {\n  padding: 8px 16px;\n  background: rgba(59, 130, 246, 0.1);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  border-radius: 6px;\n  color: #93c5fd;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.clear-filters-btn:hover {\n  background: rgba(59, 130, 246, 0.2);\n  border-color: rgba(59, 130, 246, 0.5);\n}\n\n/* Device Table */\n.device-table-wrapper {\n  overflow-x: auto;\n  background: #000000;\n  border-radius: 6px;\n}\n\n.device-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.device-table thead {\n  background: #0a0a0a;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.device-table th {\n  padding: 10px 12px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 2px solid #1f2937;\n}\n\n.device-table tbody tr {\n  cursor: pointer;\n  transition: background 0.2s;\n  border-bottom: 1px solid #1f2937;\n}\n\n.device-table tbody tr:hover {\n  background: #0a0a0a;\n}\n\n.device-table tbody tr.selected {\n  background: rgba(96, 165, 250, 0.15);\n}\n\n.device-table tbody tr.selected:hover {\n  background: rgba(96, 165, 250, 0.25);\n}\n\n.device-table td {\n  padding: 12px;\n  font-size: 14px;\n  color: #e5e7eb;\n}\n\n.device-checkbox {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #4b5563;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  background: #000000;\n}\n\n.device-row.selected .device-checkbox {\n  background: #60a5fa;\n  border-color: #60a5fa;\n  color: white;\n}\n\n.device-serial {\n  font-family: 'Courier New', monospace;\n  font-weight: 500;\n  color: #f3f4f6;\n}\n\n.device-mac {\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.device-status {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.device-status.active {\n  background: rgba(34, 197, 94, 0.15);\n  color: #86efac;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.device-status.inactive {\n  background: rgba(107, 114, 128, 0.15);\n  color: #9ca3af;\n  border: 1px solid rgba(107, 114, 128, 0.3);\n}\n\n.device-table tbody tr.assigned {\n  background: rgba(107, 114, 128, 0.15);\n  opacity: 1;\n}\n\n.device-table tbody tr.assigned:hover {\n  background: rgba(107, 114, 128, 0.2);\n}\n\n.device-table tbody tr.assigned-to-other {\n  background: rgba(239, 68, 68, 0.08);\n  opacity: 1;\n}\n\n.device-table tbody tr.assigned-to-other:hover {\n  background: rgba(239, 68, 68, 0.12);\n}\n\n.device-table tbody tr.assigned-to-other td {\n  color: #d1d5db;\n}\n\n.device-table tbody tr.assigned-to-other .device-serial {\n  color: #e5e7eb;\n  opacity: 0.9;\n}\n\n.device-table tbody tr.assigned-to-other .device-mac {\n  color: #9ca3af;\n  opacity: 0.9;\n}\n\n.device-table tbody tr.assigned-to-current {\n  background: rgba(34, 197, 94, 0.05);\n  opacity: 1;\n}\n\n.device-table tbody tr.assigned-to-current:hover {\n  background: rgba(34, 197, 94, 0.08);\n}\n\n.device-checkbox.disabled {\n  background: rgba(75, 85, 99, 0.4);\n  border-color: rgba(75, 85, 99, 0.6);\n  cursor: not-allowed;\n}\n\n.disabled-text {\n  color: #9ca3af !important;\n}\n\n.dimmed-text {\n  color: #9ca3af !important;\n}\n\n.device-status.disabled,\n.device-status.dimmed {\n  opacity: 0.8;\n}\n\n.device-site-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  background: rgba(239, 68, 68, 0.15);\n  color: #fca5a5;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.device-site-badge-assigned {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  background: rgba(251, 146, 60, 0.15);\n  color: #fb923c;\n  border: 1px solid rgba(251, 146, 60, 0.3);\n}\n\n.device-available-badge {\n  display: inline-flex;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  background: rgba(34, 197, 94, 0.15);\n  color: #86efac;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.device-available-badge.current-site {\n  background: rgba(156, 163, 175, 0.15);\n  color: #9ca3af;\n  border: 1px solid rgba(156, 163, 175, 0.3);\n  gap: 4px;\n  display: inline-flex;\n  align-items: center;\n}\n\n.device-site-badge-current {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  background: rgba(59, 130, 246, 0.15);\n  color: #60a5fa;\n  border: 1px solid rgba(59, 130, 246, 0.3);\n}\n\n.device-assigned-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.device-actions-cell {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.device-edit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: #374151;\n  border: none;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-right: 4px;\n}\n\n.device-edit-btn:hover {\n  background: #4B5563;\n  color: #fbbf24;\n  transform: scale(1.05);\n}\n\n.device-edit-btn:active {\n  transform: scale(0.95);\n}\n\n.device-reassign-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: rgba(59, 130, 246, 0.1);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  border-radius: 4px;\n  color: #60a5fa;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.device-reassign-btn:hover {\n  background: rgba(59, 130, 246, 0.2);\n  border-color: rgba(59, 130, 246, 0.5);\n  color: #93c5fd;\n  transform: translateY(-1px);\n}\n\n.device-reassign-btn:active {\n  transform: translateY(0);\n}\n\n/* Scrollbar personalizado */\n.device-selector-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.device-selector-list::-webkit-scrollbar-track {\n  background: #000000;\n  border-radius: 4px;\n}\n\n.device-selector-list::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 4px;\n}\n\n.device-selector-list::-webkit-scrollbar-thumb:hover {\n  background: #4b5563;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .filter-row {\n    grid-template-columns: 1fr;\n  }\n\n  .device-selector-header {\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-start;\n  }\n\n  .device-selector-actions {\n    width: 100%;\n  }\n\n  .device-selector-btn-secondary {\n    flex: 1;\n  }\n\n  .device-table {\n    font-size: 12px;\n  }\n\n  .device-table th,\n  .device-table td {\n    padding: 8px;\n  }\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.spin-animation {\n  animation: spin 1s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
